import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import { initialAssessmentReducer } from "./initialAssessments/reducers";
import { requestReducer } from "./shared/request/reducers";
import { onboardingReducer as onboarding } from "./onboarding/reducers";

const persistConfig = {
  key: "root",
  storage,
  whitelist: [],
};

const appReducer = combineReducers({
  initialAssessment: initialAssessmentReducer,
  request: requestReducer,
  onboarding,
});

export default persistReducer(persistConfig, appReducer);
